/** --------------------------------------------------
* 
*   CATEGORY
*
*   INFO
*   JS for "overview page" (category + brand detail)
*
*  -------------------------------------------------- */

(function($) {
  "use strict";

  $(document).ready(function() {

    // setup facet filters:
    setupFacetFilters();

    // header - anchor link:
    $('.hairco-custom__read-more-link-to-paragraphs a').on('click', function(e) {
      e.preventDefault();
      const linkUrl = $(this).attr('href');
      duo.SmoothScroll.scrollTo($(linkUrl), { 
        scrollSpeed: 1000,
        useConstantScrollSpeed: true,
        scrollAccelerator: (60/100)
      });
    });
  });

  function setupFacetFilters() {

    /*
     * drupal will also add empty facet-search blocks to the page
     * (it will add the containers, but the actual filters will be empty)
     * -> we check all of these blocks - if we find one that is empty, we add a class
     *    to it, so we can hide it via css
     */

    $('.facet-search-blocks').find('.facet-search-block').each(function(index, element) {
      const $facetSearchBlock = $(element);
      if(!$facetSearchBlock.hasClass('facet-search-block--brand-productline')) {
        let $emptyElement = $facetSearchBlock.find('.facet-empty');
        if($emptyElement.length > 0) {
          $facetSearchBlock.addClass('js-facets-empty');
        }
      } else {
        let nrOfFields = $facetSearchBlock.find('> .field').length;
        let nrOfEmpties = $facetSearchBlock.find('.facet-empty').length;
        if(nrOfFields == nrOfEmpties) {
          $facetSearchBlock.addClass('js-facets-empty');
        }
      }
    });

    /*
     * the "subcategory" filter is not a facet filter - but it will also be printed to the
     * page if it's empty
     */

    const $subCategoryBlock = $('.facet-search-blocks').find('.facet-search-block--subcategory');
    if($subCategoryBlock.length > 0) {
      // -> check the number of form-items:
      const $formItems = $subCategoryBlock.find('.subcategory-form__items > .form-item');
      if($formItems.length === 0) {
        $subCategoryBlock.addClass('js-facets-empty');
      }
    }

    // add finished class:
    $('.facet-search-blocks').addClass('js-processed');
  } /* setupFacetFilters  */
})(jQuery);
